/**
 * Report type identifiers. Each type has its own metadata shape.
 */
export const REPORT_TYPE = {
	CHEMICALS_USAGE_LOGS: 'chemicals_usage_logs',
} as const;

export type ReportType = (typeof REPORT_TYPE)[keyof typeof REPORT_TYPE];

/**
 * Metadata for chemicals usage logs report.
 * - all: export every usage log in the organization.
 * - sinceDays: export only logs with appliedAt on or after (now - days).
 *   Default days should come from organization config usageLogAliveDays when not specified.
 */
export type ChemicalsUsageLogsReportMetadata =
	| { scope: 'all'; orgId?: string }
	| { scope: 'sinceDays'; days: number; orgId?: string }
	| { scope: 'range'; startDate: Date; endDate: Date; orgId?: string };

/**
 * Metadata map per report type. Use ReportMetadataByType[ReportType] for the payload.
 */
export interface ReportMetadataByType {
	[REPORT_TYPE.CHEMICALS_USAGE_LOGS]: ChemicalsUsageLogsReportMetadata;
}

/**
 * Request body for report generation.
 * type: which report to run.
 * metadata: type-specific options (must match ReportMetadataByType[type]).
 */
export interface ReportGenerateRequest<T extends ReportType = ReportType> {
	type: T;
	metadata: ReportMetadataByType[T];
}
